<div >

    <div class="row center-item">
        <div class="col-md-12">
            <mat-form-field appearance="fill" class="full-width">
                <mat-label>Seleccionar Zona</mat-label>
                <mat-select [(ngModel)]="selectedZoneId" (selectionChange)="onZoneSelectionChange($event)">
                    <mat-option *ngFor="let zone of zones" [value]="zone.id">{{ zone.name }}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="col-md-12" *ngIf="selectedZoneId == 1">
            <!-- <mat-form-field appearance="fill" class="full-width">
                <mat-label>Seleccionar Estado</mat-label>
                <mat-select [(ngModel)]="selectedStateId" (selectionChange)="onStateSelectionChange()">
                    <mat-option *ngFor="let state of states" [value]="state.id">{{ state.name }}</mat-option>
                </mat-select>
            </mat-form-field> -->
            <button [ngClass]="{'activatedButton': startedMunicipiosSelection, 'disabledButton': !this.canSelectMunicipios}" class="btnPin" mat-raised-button (click)="toggleMunicipiosSelection()" [disabled]="!this.canSelectMunicipios">
                <p class="color-white center-item">
                    <!-- <mat-icon class="example-tab-icon">control_point</mat-icon>  -->
                    <span *ngIf="!startedMunicipiosSelection">Seleccionar Municipios</span>
                    <span *ngIf="startedMunicipiosSelection">Regresar a estado</span>
                </p>
            </button>
        </div>
    </div>

</div>